import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface MenuItem {
    id: number;
    name: string;
    icon: string;
    to_href: string | null;
    visible: boolean;
    parent_menu_item_id?: number | null;
    ParentMenuItem?: MenuItem | null;
    /** Angular route path, persisted in DB */
    route: string | null;
    MenusItemsTls?: { name: string | null }[];
    ChildMenuItems?: MenuItem[];
}

export interface Company {
    id: number;
    name: string;
    logo: string;
    menu_code: string;
    user_inactivity_timeout: number;
}

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private readonly http = inject(HttpClient);

    private readonly menuSubject = new BehaviorSubject<MenuItem[]>([]);
    menu$ = this.menuSubject.asObservable();

    private readonly companySubject = new BehaviorSubject<Company | null>(null);
    company$ = this.companySubject.asObservable();
    loadCompany(companyId: number): Observable<Company> {
        return this.http.get<Company>(`${environment.config.api_url}Companies/${companyId}`);
    }

    loadMenu(menuCode: string): Observable<MenuItem[]> {
        return this.http.get<MenuItem[]>(`${environment.config.api_url}Menus/${menuCode}/tree`);
    }

    setMenu(items: MenuItem[]): void {
        this.menuSubject.next(items);
    }

    setCompany(company: Company): void {
        this.companySubject.next(company);
    }
}
